module.exports = __webpack_public_path__ + "static/team-oezkan-isik-avatar-OberionIO-251f51be25a29e04744ea64938759abb.png";